module.exports = __webpack_public_path__ + "img/fleetroutingLogo.9c35e109.png";